import { useState } from 'react';
import { toast } from 'react-toastify';
import { Trash } from 'iconsax-reactjs';
import ConfirmModal from '../message/ConfirmModal';
import { deleteGoldenChallenge } from '../../../services/webServices/challenge/delete';

type Props = {
  id: string | number;
  onActionSuccessed: () => void;
};

export default function ChallengeAction({ id, onActionSuccessed }: Props) {
  const [isConfirmOpen, setIsConfirmOpen] = useState<boolean>(false);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);

  const handleDelete = async () => {
    if (isDeleting) return;

    setIsDeleting(true);
    const success = await deleteGoldenChallenge({ id });
    setIsDeleting(false);
    setIsConfirmOpen(false);

    if (!success) {
      toast.error('حذف سوال امکان‌پذیر نیست؛ ممکن است سوال در حال استفاده باشد.');
      return;
    }

    toast.success('سوال با موفقیت حذف شد');
    onActionSuccessed();
  };

  return (
    <div className="flex items-center justify-center gap-2 mt-2">
      <button type="button" title="حذف" disabled={isDeleting} onClick={() => setIsConfirmOpen(true)} className="p-1.5 rounded-lg text-gray-500 hover:text-errorVar-500 hover:bg-errorVar-light transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
        <Trash size={18} variant="Outline" />
      </button>

      <ConfirmModal
        isOpen={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)}
        type="confirmation"
        title="تأیید حذف سوال"
        message="آیا مطمئن هستید که می‌خواهید این سوال را حذف کنید؟ این عمل قابل بازگشت نیست."
        primaryAction={{
          text: isDeleting ? 'در حال حذف...' : 'بله، حذف کن',
          onClick: handleDelete,
          variant: 'danger',
        }}
        secondaryAction={{
          text: 'انصراف',
          onClick: () => setIsConfirmOpen(false),
        }}
      />
    </div>
  );
}
